import { ScaleLinear } from "d3"

export type TraceDrawingContext = Pick<CanvasRenderingContext2D, "beginPath" | "moveTo" | "lineTo" | "stroke"> & {
	strokeStyle: string | CanvasGradient | CanvasPattern
	lineWidth: number
}

// Draws one channel's trace as a polyline, lifting the pen across NaN gaps.
// The x transform is the closed form of a d3 time scale with domain [startTime, endTime]
// and range [0, width]; the y transform is the closed form of the linear sensitivity scale.
export function drawEEGTrace(
	context: TraceDrawingContext | null,
	times: number[],
	data: ArrayLike<number>,
	startTime: number,
	pixelsPerMs: number,
	yScale: ScaleLinear<any, any, any>,
	color: string
): void {
	if (!context) {
		return
	}

	const yZero = yScale(0)
	const ySlope = yScale(1) - yZero

	context.strokeStyle = color
	context.lineWidth = 1
	context.beginPath()

	let penDown = false

	for (let i = 0; i < data.length; i++) {
		const value = data[i]

		if (value === null || Number.isNaN(value)) {
			penDown = false
			continue
		}

		const x = (times[i] - startTime) * pixelsPerMs
		const y = yZero + value * ySlope

		if (penDown) {
			context.lineTo(x, y)
		} else {
			context.moveTo(x, y)
			penDown = true
		}
	}

	context.stroke()
}
